module.exports = __webpack_public_path__ + "img/First 100 Percent Unlocked.44991cf.png";